import React, { useEffect, useState } from 'react'
import MessageModel from '../models/message-model'

const MessageProvider: React.FC = () => {
    const [mounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])


    if (!mounted) {
        return null
    }

    return (
        <>
            <MessageModel />
        </>
    )
}

export default MessageProvider
